import { formatMsg } from './formatMsg';

/** @param {Record<string, unknown> | null} data */
export function countPendingDocs(data) {
  return (data?.recent_documents || []).filter((d) => ['pending', 'uploaded'].includes(d.status)).length;
}

/** Insight Flow IA para hub colaborador — datos del summary del portal. */
export function buildEmployeeFlowInsight(data, managerStats, persona, t) {
  if (persona === 'manager' && managerStats?.pendingLeaves > 0) {
    return {
      insight: formatMsg(t('hub93.flowMgrLeaves'), { n: managerStats.pendingLeaves }),
      action: t('hub93.flowMgrLeavesAction'),
      to: '/leaves',
    };
  }

  const pendingDocs = countPendingDocs(data);
  if (pendingDocs > 0) {
    return {
      insight: formatMsg(t('hub93.flowDocPending'), { n: pendingDocs }),
      action: t('hub93.flowDocPendingAction'),
      to: '/records',
    };
  }

  const pendExp = (data?.recent_expenses || []).filter((e) => !['paid', 'cancelled'].includes(e.status)).length;
  if (pendExp > 0) {
    return {
      insight: formatMsg(t('hub93.flowExpPending'), { n: pendExp }),
      action: t('hub93.flowExpPendingAction'),
      to: '/expense-reports',
    };
  }

  if (persona === 'rrhh') {
    return {
      insight: t('hub93.flowRrhhDefault'),
      action: t('hub93.flowRrhhDefaultAction'),
      to: '/',
    };
  }

  return {
    insight: t('hub93.flowAllClear'),
    action: t('hub93.flowAllClearAction'),
    to: '/employee-portal',
  };
}
